<template>
    <div>
        <div class="account-link-text">
            <b>Ask to link your account in-game to see your name below!</b>
            <v-btn class="user-puzzle-link" @click="onClickSubmitYourOwn"
                >Submit a user puzzle</v-btn
            >
        </div>

        <v-card-title class="search-box-card">
            <v-text-field
                class="
                    search-box
                    teal--text
                    text--lighten-3
                    v-input--is-focused
                "
                v-model="search"
                append-icon="search"
                label="Search"
                hide-details
                color="teal lighten-3"
                filled
                solo
                outlined
            ></v-text-field>
        </v-card-title>
        <div class="leaderboard">
            <v-tabs
                v-model="currentTab"
                background-color="transparent"
                color="teal lighten-3"
                slider-color="teal lighten-3"
                :grow="false"
                class="leaderboard-tabs"
            >
                <v-tab>Last 7 Days</v-tab>
                <v-tab>Last Month</v-tab>
                <v-tab>All Time</v-tab>
                <v-switch
                    background-color="transparent"
                    color="teal lighten-3"
                    v-model="linkedOnly"
                    class="mx-2 linked-user-toggle"
                    label="Linked Users Only"
                ></v-switch>
            </v-tabs>
            <v-data-table
                v-if="!loading"
                :mobile-breakpoint="0"
                :headers="headers"
                :items="leaderboardData"
                :search="search"
                :items-per-page="10"
                :loading="loading"
                no-data-text="Loading..."
                loading-text="Loading..."
                must-sort
                color="beige"
                class="table-container transparent"
            >
                <template slot="item" slot-scope="props">
                    <tr
                        class="leaderboard-row"
                        :data-userHash="props.item.userHash"
                        @click="onClickRow"
                    >
                        <td class="text-left body-2">{{ props.item.rank }}</td>
                        <td class="text-left body-2 name-column">
                            <div class="user-section">
                                <Avatar
                                    :userHash="props.item.userHash"
                                    class="user-avatar"
                                />
                                <span class="name-and-level">
                                    <div class="name">
                                        {{ props.item.name }}
                                    </div>
                                    <div class="level">
                                        Level {{ props.item.level }}:
                                        {{ getLevelName(props.item.level) }}
                                    </div>
                                </span>
                            </div>
                        </td>
                        <td class="text-right body-2">
                            {{ props.item.totalPoints }}
                        </td>
                        <td class="text-right body-2">
                            {{ props.item.puzzlesPlayed }}
                        </td>
                    </tr>
                </template>
                <v-alert
                    class="bad-search"
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                    >Your search for "{{ search }}" found no results.</v-alert
                >
            </v-data-table>
            <LoadingOwl v-if="loading" />
        </div>
    </div>
</template>

<script>
import Avatar from "./Avatar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Card from "@/components/Card.vue";
import LoadingOwl from "./LoadingOwl.vue";
import LevelManager from "@/LevelManager";

export default {
    name: "Leaderboard",
    props: ["id"],
    components: { Avatar, Card, LoadingOwl },
    data: () => {
        return {
            page: 0,
            search: "",
            currentTab: 0,
            linkedOnly: true,
            headers: [
                {
                    class: "table-header-text",
                    text: "Rank",
                    value: "rank",
                    align: "left",
                },
                {
                    class: "table-header-text",
                    text: "Name",
                    value: "name",
                    align: "left",
                },
                {
                    class: "table-header-text",
                    text: "Points",
                    value: "totalPoints",
                    align: "right",
                },
                {
                    class: "table-header-text",
                    text: "Puzzles Played",
                    value: "puzzlesPlayed",
                    align: "right",
                },
            ],
        };
    },
    mounted() {
        this.$store.dispatch("updateLeaderboard");
    },
    computed: {
        ...mapGetters(["leaderboardData", "numDays", "type"]),
        loading() {
            return !this.leaderboardData ? true : false;
        },
    },
    watch: {
        linkedOnly: function(value) {
            console.log("on change linkedOnly " + value);
            this.$store.dispatch("setType", value ? "linked" : "all");
        },
        currentTab: function(tabIndex) {
            console.log("on change tab " + tabIndex);
            if (tabIndex === 0) {
                this.$store.dispatch("setNumDays", 7);
            } else if (tabIndex === 1) {
                this.$store.dispatch("setNumDays", 30);
            } else if (tabIndex === 2) {
                this.$store.dispatch("setNumDays", 999);
            }
        },
    },
    methods: {
        onClickRow: function(e) {
            const userHash = e.currentTarget.dataset.userhash;
            this.$router.push({ path: `/profile/${userHash}` });
        },
        onClickSubmitYourOwn: function() {
            this.$router.push({ path: `/submityourown` });
        },
        getLevelName(level) {
            if (level) {
                return `Puzzle ${LevelManager.getRankName(level)}`;
            }
            return "";
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.linked-user-toggle {
    justify-content: flex-end;
}
.leaderboard {
    display: flex;
    flex-direction: column;

    text-align: center;
    justify-content: space-between;
    width: unset;
    margin: 10px;

    left: 0;
    right: 0;
    padding: 10px 20px 30px 20px;
    width: 90%;
    margin: auto;
    border: 2px solid $pod-teal;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    .leaderboard-tabs {
        padding-bottom: 15px;
    }
}

@media only screen and (max-width: 600px) {
    .leaderboard {
        padding: 0 !important;
    }
}

.leaderboard-header {
    margin-bottom: 5px;
    text-align: left;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    justify-content: space-around;
    cursor: pointer;
    &:hover {
        background-color: rgba(255, 255, 255, 0.5) !important;
    }
}

.leaderboard-row {
    cursor: pointer;
}

.user-section {
    display: flex;
    align-items: center;
    .name-and-level {
        .name {
            font-weight: bold;
        }
        .level {
            font-size: 12px;
            font-style: italic;
        }
    }
}

.account-link-text {
    padding-top: 10px;
    color: white;
}

.user-puzzle-link {
    margin: 10px;
}

.search-box-card {
    padding: 20px 0px;
    width: 90%;
    left: 0;
    right: 0;
    margin: auto;
}
.search-box {
    padding: 10px 0px;
}
.user-avatar {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
}
</style>
<style lang="scss">
.v-tabs-bar__content {
    align-items: center;
}
.v-input__slot {
    background: rgba(255, 255, 255, 0.9) !important;
    &:hover {
        background: rgba(255, 255, 255, 0.9) !important;
    }
}
.v-slide-group__prev {
    display: none !important;
}
.leaderboard .v-input__control .v-input__slot {
    background: transparent !important;
}
</style>
